import styles from './SubSection.module.css';

interface SubSectionInformationProps {
  subSectionKey?: string;
  informationList?: string[];
}

export default function SubSectionInformation({
  subSectionKey,
  informationList = []
}: SubSectionInformationProps) {
  return (
    subSectionKey &&
    informationList?.map((info, i) => (
      <div
        className={styles.information}
        id={`${subSectionKey}-hint-${i}`}
        key={`${subSectionKey}-hint-${i}`}>
        {info}
      </div>
    ))
  );
}
